import {Helmet} from "react-helmet-async";
import {FaPhoneSquareAlt} from "react-icons/fa";
import {IoMdMail} from "react-icons/io";

import ContentContainer from "@/components/layout/ContentContainer.tsx";
import {ErrorFallback} from "@/lib/handlers/ErrorFallback.tsx";
import {UpErrorBoundary} from "@/lib/handlers/UpErrorBoundary.tsx";
import {ContactFormAction} from "@/pages/website/contact/ContactFormAction.tsx";

export const ContactPage = () => (
  <UpErrorBoundary
    fallback={
      <ContentContainer title="Contact Us">
        <ErrorFallback />
      </ContentContainer>
    }
  >
    <ContentContainer title="Contact Us">
      <Helmet>
        <title>Contact Us</title>
      </Helmet>
      <div className="container">
        <div className="row">
          <div className="col">
            <ContactFormAction />
          </div>
          <div className="offset-lg-1 col">
            <h4>Call Us</h4>
            <p>
              <FaPhoneSquareAlt />
              <span className="ps-1">+1 877-910-3129</span>
            </p>
            <hr className="mb-4" />
            <h4>Email Support</h4>
            <p>
              <IoMdMail />
              <span className="ps-1">
                <a href="mailto:support@uptime.com">support@uptime.com</a>
              </span>
            </p>
            <hr className="mb-4" />
            <h4>Address</h4>
            <p>
              Uptime.com
              <br />
              5380 Gulf of Mexico Dr.
              <br />
              Ste 105
              <br />
              Longboat Key, FL 34228
            </p>
          </div>
        </div>
      </div>
    </ContentContainer>
  </UpErrorBoundary>
);
